const common = {
    projectName: 'Eagle Systems',
    serverDown:false,
    message:"Server is down. Please try again later."
};

const hostname = window.location.hostname;
const hostWithPermissionCheck = [
    'dispatch.eaglegroup.com',
    "localhost",
    'test.eaglegroup.com',
  ]
  const enablePermissionCheck = hostWithPermissionCheck.includes(hostname)

let apiConfig = {};

if (hostname === 'dispatch.eaglegroup.com') {
    // Production
    apiConfig = {
        URL: 'https://api.eaglegroup.com/api',
        URL2: 'https://api.eaglegroup.com/auth',
        WSURL: 'wss://api.eaglegroup.com',
    };
} else if(hostname === 'dispatch-temp.eaglegroup.com') {
    // Production
    apiConfig = {
        URL: 'https://apiv2.eaglegroup.com/api',
        URL2: 'https://apiv2.eaglegroup.com/auth',
        WSURL: 'wss://apiv2.eaglegroup.com',
    };
} else if (hostname === 'test.eaglegroup.com') {
    // Test
    apiConfig = {
        URL: 'https://testdispatchapi.eaglegroup.com/api',
        URL2: 'https://testdispatchapi.eaglegroup.com/auth',
        WSURL: 'wss://testdispatchapi.eaglegroup.com',
    };
} else if (hostname === 'dev.eaglegroup.com') {
    // Development
    apiConfig = {
        URL: 'https://devapi.eaglegroup.com/api',
        URL2: 'https://devapi.eaglegroup.com/auth',
        WSURL: 'wss://devapi.eaglegroup.com',
    };
} else {
    // Default (Fallback)
    apiConfig = {
        URL: 'http://localhost:3002/api',
        URL2: 'http://localhost:3002/auth',
        WSURL: 'ws://localhost:3002',
    };
}


const config = {
  ...common,
  api: apiConfig,
  enablePermissionCheck,
};

export default config;

// const config = {
//     production: {
//         ...common,
//         api: apiConfig,
//         // {
//         //     // URL: 'https://dispatch.eaglegroup.com/api',
//         //     URL: 'https://testdispatchapi.eaglegroup.com/api',
//         //     URL2: 'https://testdispatchapi.eaglegroup.com/auth',
//         //     WSURL: 'wss://testdispatchapi.eaglegroup.com'
//         // },
//         enablePermissionCheck

//     },
//     development: {
//         ...common,
//         api: {
//             URL: 'http://localhost:3002/api',
//             URL2: 'http://localhost:3002/auth',
//             WSURL: 'ws://localhost:3002',
//         },
//         enablePermissionCheck
//     },
//     testing: {
//         ...common,
//         api: {
//             URL: 'http://test-alb-1724792386.us-west-2.elb.amazonaws.com/api',
//             URL2: 'http://test-alb-1724792386.us-west-2.elb.amazonaws.com/auth',
//             WSURL: 'ws://test-alb-1724792386.us-west-2.elb.amazonaws.com',
//         },
//         enablePermissionCheck
//     }
// };


// export default config.testing;
//export default config[process.env.NODE_ENV] || config.development;
